import * as React from 'react';
import autobind from "autobind-decorator";
import { observable } from "mobx";
import { observer } from "mobx-react";
import { resolve } from "inversify-react";

import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';
import { ControllerProps } from 'src/router';
import { DialogService } from "src/core/services/ui/dialog.service";
import { ClientListView } from './client-list.view';
import { ClientListDataService } from './client-list.data';

@observer
export class ClientListController extends React.Component<ControllerProps<any>, any> {

    @observable
    protected dataService: ClientListDataService;

    @resolve
    protected dialogService: DialogService;

    @resolve
    protected toast: ToastNotifications;

    public constructor(props) {
        super(props);
        this.dataService = ClientListDataService.make();
        this.setupFilters();
    }

    protected setupFilters() {

    }

    public componentDidMount() {
        this.loadData();
    }

    @autobind
    protected onItemDoubleClicked(item: ClientSummary | 'Person' | 'Company') {
        this.props.history.push(`/crm/clients/${item == 'Person' || item == 'Company' ? item : item.id}`);
    }

    @autobind
    protected loadData() {
        this.props.setBusy(true);
		this.dataService.addSorting('id', 'asc', true);
		this.dataService.addFilter('isDeleted', 'eq', false);
        this.dataService.load(query => query)
            .then(() => this.props.setBusy(false))
            .catch(error => {
                this.props.setBusy(false);
                this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
            });
    }

    public render() {
        return <ClientListView
            model={this.dataService}
            setBusy={this.props.setBusy} onItemDoubleClicked={this.onItemDoubleClicked} {...this.props} />
    }
}



// WEBPACK FOOTER //
// ./src/app/crm/clients/list/client-list.controller.tsx